import { PERTURBATIONS } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case PERTURBATIONS.PERMANENTES:
        return 'Permanentes';
      case PERTURBATIONS.ALEATOIRES:
        return 'Aléatoires';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/perturbations.filter.js